module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/kassie-green-ba98511ef1801640978e14c0a8ed664d.jpg";